"use strict";
let start = {
	obj: {}
}
Object.defineProperty(start, 'list', {
	set: function (hz) {
		// console.dir(hz);
		this.obj[hz.name] = hz;
	},
	get: function() {
		for(let key in this.obj) {
			this.obj[key]();
			console.log(this.obj[key]);
		}
	}
});
module.exports = start;


// WEBPACK FOOTER //
// ./libs/_startFunction.js